"use client";
import React from "react";
import YourBusinessDashboard from "./YourBusinessDashboard";

export default function YourBusiness() {
  return (
    <div className="min-h-screen bg-[#F7F8FA]">
      <YourBusinessDashboard />
    </div>
  );
}
